import { Fragment } from 'react';
import { LinkButton } from 'styles-js/buttons';
import { helpScoutArticle } from 'src/utils/helpscoutBeacon';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event } from 'src/constants/footfall';
import i18n from 'src/utils/translate';

export default function AcceptTerms() {
  return (
    <Fragment>
      <p>
        {i18n.t('We want you to understand how our service works. Please review')}{' '}
        <LinkButton onClick={() => {
          trackFootfallEvent(Event.CLICKED, { clickType: 'join-our-terms' });
          helpScoutArticle('147-terms', { type: 'modal' });
        }}>
          {i18n.t('our terms')}
        </LinkButton>
        {' '}{i18n.t('and')}{' '}
        <LinkButton onClick={() => {
          trackFootfallEvent(Event.CLICKED, { clickType: 'join-privacy' });
          helpScoutArticle('148-privacy', { type: 'modal' });
        }}>
          {i18n.t('privacy policy')}
        </LinkButton>.
      </p>
      <div className="signup-box__tips">
        <h4 className="signup-box__highlights">{i18n.t('The highlights')}</h4>
        <ul>
          <li>{i18n.t('You must be 18 or older')}</li>
          <li>{i18n.t('Your contact information is not shared with 3rd parties without your consent')}</li>
          <li>{i18n.t('Do not use the site as a substitute for professional health advice')}</li>
          <li>{i18n.t('Your contributions must comply with the laws of the country from which they are posted')}</li>
          <li>{i18n.t('We only use information about you consistent with applicable law')}</li>
        </ul>
      </div>
    </Fragment>
  );
}
